import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const itamSettingsRoute: InvariantJiraRoute = {
	name: 'itam-settings',
	path: '/jira/itam/:practice/settings/:menu_item?',
	exact: true,
	query: ['role?'],
};
